import * as LeadGrid from '../Services/LeadGridCms'
import { isResErrorType } from '../Services/LeadGridCms'
import * as Notification from '../Services/Notification'
import * as Actions from './CmsActions'

export const initialize = (siteName) => async (dispatch) => {
  dispatch({ type: Actions.START_INITIALIZE })

  const [workspaceRes, permission, postTypes, taxonomies, forms, site] =
    await Promise.all([
      LeadGrid.findWorkspace(),
      LeadGrid.findAllPermission(),
      LeadGrid.findAllPostType(siteName),
      LeadGrid.findAllTaxonomy(siteName),
      LeadGrid.getAllForm(),
      LeadGrid.findSite(siteName),
    ])

  if (!workspaceRes.data || isResErrorType(workspaceRes.data)) {
    Notification.error('ワークスペースの取得に失敗しました', '')
    return
  }

  dispatch({
    type: Actions.LOADED_INITIAL_SITE_VALUES,
    payload: {
      site: changeSiteData(site.data),
      postTypes: postTypes,
      taxonomies: taxonomies,
      workspace: workspaceRes.data,
      permissions: permission.data,
      forms: forms,
    },
  })

  dispatch({
    type: Actions.FINISH_INITIALIZE,
  })
}

const changeSiteData = (siteData) => {
  const {
    id,
    name,
    display_name,
    domain,
    domain_type: domainType,
    deploy_mode,
    public: isPublic,
    site_monitoring,
    is_used_seo_tag,
    is_used_seo_tag_v2,
    is_used_embed_script_tag,
    is_used_favicon_tag,
    is_create_post_type,
    has_top_page,
  } = siteData
  return {
    id,
    name: name,
    domain: domain,
    domainType,
    deploy_mode,
    display_name,
    isPublic,
    site_monitoring,
    is_used_seo_tag,
    is_used_seo_tag_v2,
    is_used_embed_script_tag,
    is_used_favicon_tag,
    is_create_post_type,
    has_top_page,
  }
}
